import { encore, resto, userService } from '@saucelabs/sl-util-axios';

export const checkResto = () => (
  resto.get('/rest/v1/hello')
);

export const checkEncore = () => (
  encore.get('/api/whoami')
);

export const checkUserService = () => (
  userService.get('/v1/users/me/')
);
